<template>
  <div>
    <incident-list v-if="$route.name === 'incident-list'"></incident-list>
    <router-view v-else></router-view>
  </div>
</template>

<script setup lang="ts">
import IncidentList from './IncidentList.vue'

defineOptions({
  name: 'IncidentIndex',
})
</script>
